import styled from "styled-components";

const Wrapper
	= styled.div`
		display: inline-block;
		color: white;

		> * {
			display: inline-flex;
			width: calc(20px + 1vw);
			height: calc(20px + 1vw);
		}
	`

export default Wrapper
